const FEATURES = {
  docSigning: {
    production: { AT: true },
    staging: { AT: true, NO: true },
    test: true,
  },
  nfc: {
    production: { NO: true },
    staging: { NO: true, AT: true },
    test: true,
  },
  pts: {
    production: true,
    staging: true,
    test: false,
  },
  locale: false,
}

// Allow for specific exclusions of features
const EXCLUSIONS = {}
// const EXCLUSIONS = {
//   nfc: {
//     location: ['EVO Kirkenes-Hesseng'],
//   },
// }

const featureEnabled = (name, locale, env) => {
  const country = locale.length === 5 ? locale.substring(3) : locale.toUpperCase()

  if (!FEATURES[name]) return false
  if (typeof FEATURES[name] === 'boolean') return FEATURES[name]

  const feature = FEATURES[name]
  if (!feature[env]) return false
  if (typeof feature[env] === 'boolean') return feature[env]

  const featureEnv = feature[env]
  if (!featureEnv[country]) return false
  return featureEnv[country] || false
}

const featureExcluded = (name, type, value) => {
  if (!EXCLUSIONS[name]) return false

  if (!EXCLUSIONS[name][type]) return false

  if (EXCLUSIONS[name][type].includes(value)) return true

  return false
}

export {
  featureEnabled, featureExcluded,
}
